export default "__VITE_ASSET__BoBc81eY__"